import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PAYMENTS_SAVE_PAYMENT_CHECKMARK_CONFIG = createFcmDetails(
	'payments_save_payment_checkmark_config',
	{
		owner: 'Membership/Payments Squad',
		context: 'Used on the Promote and Membership Join Page',
		import: false,
		description:
			'This config allows you to control whether the save my payment info checkbox field remains selected or unselected',
	},
);
